import { render, staticRenderFns } from "./ScreenEndOfLifeReport.vue?vue&type=template&id=3d305a01&"
import script from "./ScreenEndOfLifeReport.vue?vue&type=script&lang=js&"
export * from "./ScreenEndOfLifeReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports